import {teamsAppIdsV3} from '@/constants/teams.js'
import {useEnv} from '@/composables/use-env.js'
import {computed} from 'vue'

//Get environment
const {isLocal, isDev, isQa, isStaging, isProduction} = useEnv()

//Teams app ID (V3)
const teamsAppIdV3 = computed(() => {
  if (isLocal.value || isDev.value) {
    return teamsAppIdsV3.DEV
  }
  if (isQa.value) {
    return teamsAppIdsV3.QA
  }
  if (isStaging.value) {
    return teamsAppIdsV3.STAGING
  }
  if (isProduction.value) {
    return teamsAppIdsV3.PRODUCTION
  }
  throw new Error('Unknown environment')
})

/**
 * Teams app IDs composable
 */
export function useTeamsAppIds() {
  return {
    teamsAppIdV3,
  }
}
